import React from 'react';
import { TransparentButton } from './TransparentButton';
import pencilIcon from '../../accets/icons/pencil-icon.svg';
import greyPencilIcon from '../../accets/icons/grayPencilIcon.svg';
import styled from 'styled-components';

export const ButtonIcon = styled.img<{ size?: number }>`
  width: ${props => (props?.size ? `${props.size}px` : 'inherit')};
`;

export const EditButton = ({
  onClick,
  size,
  active,
}: {
  onClick(): void;
  size?: number;
  active?: boolean;
}): JSX.Element => {
  return (
    <TransparentButton onClick={onClick}>
      <ButtonIcon size={size} src={active ? pencilIcon : greyPencilIcon} alt="icon" />
    </TransparentButton>
  );
};
